import React, { Component } from "react";
import { getThemeSettingsVariables } from "../../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import { DialogSaveButton } from "../../../common/Global/globalStyles.style";

let themeSettings = getThemeSettingsVariables();

class AddDescriptionDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scores: [],
      descriptions: {},
      errors: {} 
    };
    themeSettings = getThemeSettingsVariables();
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showDescriptionDialog) {
      this.setState({
        scores: this.props.scores,
        descriptions: this.props.descriptions,
        errors: {} 
      })
    }
  }

  

  handleDescriptionChange = (value, e) => {
    const inputVal = e.target.value; // capture before setState

    this.setState((prevState) => ({
      descriptions: {
        ...prevState.descriptions,
        [value]: inputVal
      },
      errors: {
        ...prevState.errors,
        [value]: ""  // clear error for this field
      }
    }));
  };

  handleSaveDescription = () => {
    const { scores, descriptions } = this.state;

    // Check if at least one description is filled
    const hasAnyFilled = Object.values(descriptions).some(val => val && val.trim() !== "");

    let errors = {};
    if (hasAnyFilled) {
      scores.forEach((value) => {
        if (!descriptions[value] || descriptions[value].trim() === "") {
          errors[value] = "Description is required";
        }
      });
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return; // stop save
    }

    this.setState({ errors: {} }, () => {
      this.props.handleSaveDescription(this.state.descriptions);
    });
  }
  
  render() {
    const { scores, descriptions } = this.state;
    return (
      <Modal
        className="custom-dialog value-desc-dialog"
        show={this.props.showDescriptionDialog}
        backdrop="static"
      >
        <Modal.Header>
          <h5>
            {this.state.isEdit ? "Edit Description" : "Add Description"}
          </h5>
          <button
            onClick={this.props.handleDescriptionDialogClose}
            type="button"
            data-dismiss="modal"
          >
            <span class="material-icons">close</span>
          </button>
        </Modal.Header>
        <hr />
        <div class="modal-body">
          <div className="common-tab-bg my-2 body-wrapper">
            <div 
              className="common-table"
              style={{ border: "1px solid #e5e5e5" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>Value</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {scores.map((value, index) => (
                    <tr key={index}>
                      <td>
                        {value}
                      </td>
                      <td>
                        <div className="addnew-modal-form-group flex-center-layout mt-2 mb-2"
                        style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                          <input 
                            type="text" 
                            placeholder="Enter Description"
                            name="fieldName" 
                            value={descriptions[value] || ""}
                            onChange={(e) => this.handleDescriptionChange(value, e)}
                          />
                          {this.state.errors[value] && (
                            <span className="cm-error">{this.state.errors[value]}</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-close-save">
            <div class="close-save-col">
              <button
                onClick={this.props.handleDescriptionDialogClose}
                type="button"
                class="modal-close"
              >
                Cancel
              </button>
              <DialogSaveButton
                themeSettings={this.props.themeSettings}
                onClick={this.handleSaveDescription}
                type="button"
              >
                Save
              </DialogSaveButton>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default AddDescriptionDialog;
